jQuery(document).ready(function ($) {
    $('.hide-filters-desktop').click(function () {
        if ($(this).hasClass('show-filters')) {
            $(this).removeClass('show-filters').find('span').text('Hide Filters')
            $(this).closest('#MainContent').removeClass('hide-filters');
        } else {
            $(this).addClass('show-filters').find('span').text('Show Filters')
            $(this).closest('#MainContent').addClass('hide-filters');
        }
    });

    // $('.collection-filter__title').click(function () {
    //     $(this).toggleClass('collapsed').next().slideToggle();
    //     $(this).closest('.collection-filter__group').toggleClass('collapsed');
    // });

    $('.hide-and-results .hide-filters-mobile').click(function () {
        $(this).closest('.collection-filters-result').toggleClass('show-filters');
        $(this).closest('.collection-filters').toggleClass('show-filters');
    });

    $('.filter-form-close').click(function () {
        console.log('asdkahsk');
        $(this).closest('.collection-filters-result').removeClass('show-filters');
        $(this).closest('.collection-filters').removeClass('show-filters');
    });
    $('.template-search .show-result').click(function (e) {
        e.preventDefault();
        $(this).closest('.collection-filters').toggleClass('show-filters');
    })

    // $('.clear-all').click(function (e) {
    //     e.preventDefault();
    //     $(this).closest('.tag-list').find('.tag--remove').click().trigger('click');
    // });

    $(".site-navigation .site-nav__item").hover(function () {
        var index = $(this).index();
        if ($(this).hasClass('site-nav--has-dropdown')) {
            $('.submenu-div').addClass('active');
            $('.submenu-div .submenu-list').children().removeClass('active');
            $('.submenu-div .submenu-list').children().eq(index).addClass('active');
        } else {
            $('.submenu-div').removeClass('active');
        }
    }, function () {
        $('.submenu-div').removeClass('active');
    });

    $(".submenu-div").hover(function () {
        $(this).addClass('active');
    }, function () {
        $(this).removeClass('active');
    });

    // Open nav in mobile
    $('.button-navigation-mobile').click(function () {
        if ($(this).hasClass('open')) {
            $(this).removeClass('open');
            $(this).closest('.header-item--navigation').removeClass('open');
            $('.site-navigation').removeClass('open-subnav');
            $('.site-navigation .site-nav--has-dropdown').removeClass('open-subnav');
            $('body').removeClass('open-nav');
        } else {
            $(this).addClass('open');
            $(this).closest('.header-item--navigation').addClass('open');
            $('body').addClass('open-nav');
        }
    });

    //Open sub-nav
    $('.site-nav--has-dropdown .site-nav__link').click(function (e) {
        if ($(window).width() <= 999) {
            e.preventDefault();
        }
        if ($(this).closest('.site-nav--has-dropdown').hasClass('open-subnav')) {
            $(this).closest('.site-nav--has-dropdown').removeClass('open-subnav');
            $(this).closest('.site-navigation').removeClass('open-subnav');
        } else {
            $(this).closest('.site-navigation').addClass('open-subnav');
            $(this).closest('.site-navigation').find('.site-nav--has-dropdown').removeClass('open-subnav');
            $(this).closest('.site-nav--has-dropdown').addClass('open-subnav')
        }
        // if ($(this).closest('.site-nav--has-dropdown').hasClass('open-subnav')) {
        //     $(this).closest('.site-nav--has-dropdown').hasClass('open-subnav')
        // } else {
        //     $(this).closest('.site-nav--has-dropdown').hasClass('open-subnav')
        // }
    });

    //Close sub-nav
    $('.submenu-title').click(function () {
        if ($(this).closest('.site-nav--has-dropdown').hasClass('open-subnav')) {
            $(this).closest('.site-nav--has-dropdown').removeClass('open-subnav');
            $(this).closest('.site-navigation').removeClass('open-subnav');
        }
    });

    $(".site-nav--has-dropdown>.site-nav__link").hover(function () {
        $('header.site-header').addClass('header-overlay-hover');
    }, function () {
        $('header.site-header').removeClass('header-overlay-hover');
    });

    $('.header-item--navigation-overlay').on('click', function () {
        $(this).closest('.header-item--navigation').removeClass('open');
        $(this).closest('.header-item--navigation').find('.button-navigation-mobile').removeClass('open');
    })
});
